import * as styles from "./FavouriteIcon.module.scss";

import { HeartFilled } from "../common/Icons";

import React from "react";
import { useFavouritesManager, useMyAccount } from "../../context";
import { useFavouriteDog } from "../../hooks/useFavouriteDog";
import { Colours } from "../../utils/colours";
import { getCookie } from "../../utils/cookies";

export interface FavouriteIconProps {
	dog: DogsTrust.DogData;
	size?: "xsmall" | "small" | "medium" | "large";
	dogData?: DogsTrust.EventDogData;
}

export const FavouriteIcon: React.FC<FavouriteIconProps> = ({
	dog,
	dogData,
	size = "small",
}) => {
	const { isFav, onClick } = useFavouriteDog(dog);
	const { onFaveClick } = useFavouritesManager();
	const { isAuthenticated } = useMyAccount();

	const getIconSize = () => {
		switch (size) {
			case "xsmall":
				return { height: "23px", width: "23px" };
			case "small":
				return { height: "30px", width: "30px" };
			case "medium":
				return { height: "50px", width: "50px" };
			case "large":
				return { height: "80px", width: "80px" };
		}
	};

	const getWrapperSize = () => {
		switch (size) {
			case "xsmall":
				return { height: "27px", width: "27px" };
			case "small":
				return { height: "50px", width: "50px" };
			case "medium":
				return { height: "80px", width: "80px" };
			case "large":
				return { height: "120px", width: "120px" };
		}
	};

	const onFaveClickHandler = () => {
		if (
			onFaveClick &&
			!isAuthenticated &&
			!isFav &&
			!getCookie(process.env.GATSBY_FAVDOG_CREATE_ACC_COOKIE_NAME) &&
			process.env.GATSBY_FEATURE_FLAG_MY_ACCOUNT === "true"
		) {
			onFaveClick?.(dogData, "add", dog);
		} else if (onFaveClick && isFav) {
			onFaveClick?.(dogData, "remove", dog);
		} else onClick?.(dogData);
	};
	return (
		<button
			type="button"
			className={styles.favouriteiconwrapper}
			style={{ ...getWrapperSize() }}
			onClick={() => onFaveClickHandler()}
			tabIndex={0}
			onKeyDown={(e) => e.key === "Enter" && onClick(dogData)}
		>
			{isFav ? (
				<>
					<HeartFilled
						fillPrimary={Colours.SUNSHINE_YELLOW}
						fillSecondary={Colours.MIDNIGHT}
						{...getIconSize()}
					/>
					{`Unfavourite ${dogData.card_title}`}
				</>
			) : (
				<>
					<HeartFilled
						fillPrimary={Colours.WHITE}
						fillSecondary={Colours.MIDNIGHT}
						{...getIconSize()}
					/>
					{`Favourite ${dogData.card_title}`}
				</>
			)}
		</button>
	);
};

export default FavouriteIcon;
